import "./index.css";
import React, { Fragment, useEffect, useState, useRef } from "react";
import Firebase from "../../firebasehelper";
import Header from "../../components/Header";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import TableRow from "./components/TableRow";
import ReviewModal from "./components/ReviewModal";
import generatePassword from "generate-password";
import {
  sendBrandAdminPasswordEmail,
  sendBrandAdminRegistrationEmail,
} from "../../api/UserApi";
import { getFilePath } from "../../Utils/utils";
import { IMAGE_UPLOAD } from "../../Constants/types";

export default function PendingCommunities() {
  const [pendingBrands, setPendingBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [loading, setLoading] = useState(false);
  const closeBtnRef = useRef();

  const location = useLocation();
  const history = useHistory();

  const tableHeaders = ["Client", "Name", "Submitted on"];

  const onBrandClick = (brand) => {
    setSelectedBrand(brand);
  };

  const openTicket = (brand_id, firstname) => {
    return new Promise(async (resolve, _reject) => {
      const type = "Account management";
      let time = new Date().getTime().toString();
      const ticket_id = await Firebase.createAdminSupport(brand_id, {
        type,
        time,
        signup: true,
      });
      Firebase.addSupportMessages(brand_id, ticket_id, [
        {
          message: `Hi ${firstname}`,
          type: "admin",
          username: "Bot",
          time: new Date().getTime().toString(),
        },
        {
          message: `Welcome to your Ecosystem`,
          type: "admin",
          username: "Bot",
          time: new Date().getTime().toString(),
        },
        {
          message: `You can explore the features using navigation.`,
          type: "admin",
          username: "Bot",
          time: new Date().getTime().toString(),
        },
        {
          message: `May I help you with any questions you have?`,
          type: "admin",
          username: "Bot",
          time: new Date().getTime().toString(),
        },
      ]);
      resolve(ticket_id);
    });
  };

  const onReject = async () => {
    const logoPath = getFilePath(
      "brand_logo",
      selectedBrand.logo,
      IMAGE_UPLOAD
    );
    const iconPath = getFilePath(
      "brand_icon",
      selectedBrand.icon,
      IMAGE_UPLOAD
    );

    try {
      await Firebase.deleteFile(logoPath);
      await Firebase.deleteFile(iconPath);
      await Firebase.deletePendingBrand(selectedBrand.name);

      setPendingBrands(
        pendingBrands.filter((brand) => brand.name !== selectedBrand.name)
      );
      setSelectedBrand(null);
    } catch (err) {
      console.log("onReject() error", err);
    }
    closeBtnRef.current.click();
  };

  const onApprove = async () => {
    setLoading(true);
    const { logo, website, hexcode, icon, name, firstname, email, territory } =
      selectedBrand;

    const tempPass = generatePassword.generate({
      length: 10,
      numbers: true,
    });

    Firebase.addBrandUrl(
      name,
      website,
      logo,
      icon,
      hexcode || "#FAFAFA",
      territory || "UK",
      true,
      (brand_id) => {
        // creating Agency against email
        Firebase.addAgency(email, tempPass)
          .then(async (uid) => {
            Firebase.writeAgencydata(uid, {
              uid: uid,
              username: firstname,
              role: 2,
              brand: brand_id,
              approved: true,
              email: email,
              shouldReset: true,
            });
            // send brand admin password email
            await sendBrandAdminPasswordEmail(email, firstname, name, tempPass);
            // send admin registered email
            await sendBrandAdminRegistrationEmail(name, firstname);
            // creating auto mail account
            Firebase.createDefaultBrandAdmin(brand_id, name);
            // create ticket
            await openTicket(brand_id, firstname);

            // remove pending brand from collection and state
            await Firebase.deletePendingBrand(selectedBrand.name);
            setPendingBrands(
              pendingBrands.filter((brand) => brand.name !== selectedBrand.name)
            );
            setSelectedBrand(null);

            setLoading(false);
            closeBtnRef.current.click();
          })
          .catch((err) => {
            alert(err);
            closeBtnRef.current.click();
          });
      }
    );
  };

  useEffect(() => {
    const getPendingBrands = async () => {
      const res = await Firebase.getPendingBrands();
      setPendingBrands(res);
    };

    const { role } = location.state;
    if (!location.state || (role !== 0 && role !== 10)) history.push("/");

    getPendingBrands();
  }, []);

  return (
    <div id="page-container">
      <Header
        username={location.state && location.state.username}
        role={location.state && location.state.role}
      />
      <main className="pending-brands">
        <table className="pending-brands__table">
          <thead className="pending-brands__table-head">
            <tr className="pending-brands__table-headers">
              {tableHeaders.map((header, i) => (
                <th
                  className={`pending-brands__table-header ${
                    header === "Client"
                      ? "pending-brands__table-header-logo"
                      : ""
                  } ${
                    header === "Name" ? "pending-brands__table-header-name" : ""
                  }`}
                  key={i}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {pendingBrands.length ? (
              pendingBrands.map((brand, i) => (
                <Fragment key={`${i}-${brand.email}`}>
                  <TableRow brand={brand} onBrandClick={onBrandClick} />
                </Fragment>
              ))
            ) : (
              <tr>
                <td>
                  <p className="pending-brands__empty-msg">
                    There are currently no pending brands
                  </p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <ReviewModal
          selectedBrand={selectedBrand}
          onReject={onReject}
          onApprove={onApprove}
          closeBtnRef={closeBtnRef}
          loading={loading}
        />
      </main>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/PendingCommunities/index.js